import { AppsKeysPage } from './AppsKeysPage';

export const AppsKeysTab = () => <AppsKeysPage embedded />;
